export const copyToClipboard = async (
  text,
  { onSuccessAction, onErrorAction } = {},
) => {
  const { isSecureContext } = window
  const isClipboardAvailable = window.navigator?.clipboard

  try {
    if (!isSecureContext || !isClipboardAvailable) {
      throw new Error('Clipboard API is not supported in your browser.')
    }

    await navigator.clipboard.writeText(text)

    onSuccessAction && onSuccessAction()
  } catch (error) {
    onErrorAction && onErrorAction()

    throw new Error(error)
  }
}
